<form autocomplete="off" #form="ngForm">
    <ui-card>
        <div class="app-grid">
            <h2>{{ 'forms.change-requests.templateActivation' | translate }}</h2>
            <div class="toggle">
                <div>
                    <h4 role="group" id="activate-template-name" class="margin-bottom-1">
                        {{ 'forms.change-requests.activateThisTemplate' | translate }}
                    </h4>
                    <p class="description" id="activate-template-desc">
                        {{ 'forms.change-requests.activatedDeactivatedTemplatesInstruction' | translate }}
                    </p>
                </div>
                <mat-slide-toggle
                    color="primary"
                    [(ngModel)]="changeRequestTemplate.isActive"
                    name="isActive"
                    aria-labelledby="activate-template-name"
                    aria-describedby="activate-template-desc"
                ></mat-slide-toggle>
            </div>
        </div>
    </ui-card>

    <ui-card>
        <div class="app-grid">
            <h2 class="margin-bottom-3">{{ 'forms.change-requests.summary' | translate }}</h2>

            <div class="review-item columns-12 margin-bottom-3">
                <h4>{{ 'forms.change-requests.requestName' | translate }}</h4>
                <p>
                    {{
                        ChangeRequestTemplateDisplayOptions[changeRequestTemplate.name] || changeRequestTemplate.name
                            | translate
                    }}
                </p>
            </div>

            <div class="review-item columns-12 margin-bottom-3">
                <h4>{{ 'forms.change-requests.requestDescription' | translate }}</h4>
                <p style="white-space: pre-wrap">{{ changeRequestTemplate.description }}</p>
            </div>

            <div class="review-item columns-12 margin-bottom-3">
                <h4>{{ 'forms.change-requests.includedFields' | translate }}</h4>
                <ul class="margin-bottom-0">
                    <li *ngFor="let field of changeRequestTemplate.changeRequestTemplateFields">{{ field.name }}</li>
                </ul>
            </div>
        </div>

        <hr class="margin-bottom-3" />

        <h3 class="margin-bottom-3">{{ 'forms.change-requests.requestersAndApprovers' | translate }}</h3>

        <div class="review-item columns-12 margin-bottom-3">
            <h4>{{ 'forms.change-requests.requestSubmitter' | translate }}</h4>
            @for (name of selectedRoleNames; track $index) {
                @if ($index > 0) {
                    <span>,&nbsp;</span>
                }
                <span>{{ name | translate }}</span>
            }
        </div>

        <div class="review-item columns-12 margin-bottom-3">
            <h4>{{ 'forms.change-requests.requestApprover' | translate }}</h4>
            <div class="app-grid margin-bottom-2" *ngFor="let step of approvalWorkflow.steps">
                <div class="columns-1">{{ step.orderPosition | ordinalNumber }}</div>
                <div class="columns-11">{{ approverLabel(step) | translate }}</div>
            </div>
        </div>

        <div class="review-item columns-12 margin-bottom-3">
            <h4>{{ 'forms.change-requests.requestNotifiable' | translate }}</h4>
            <p *ngIf="notifySubject">
                {{ 'forms.change-requests.requestCreatorAndSubjectEtcVisibilityInstruction' | translate }}
            </p>
            <p *ngIf="!notifySubject">
                {{ 'forms.change-requests.requestSubjectDirectManagerNotifiedInstruction' | translate }}
            </p>
        </div>
    </ui-card>
</form>
